import { OpportunitySuggestion } from "@marta/common-utils";

export type Message = {
  id?: string;
  createdAt?: Date;
  senderId: string;
  senderName: string;
  message: string;
  messageStatus?: {
    id?: string;
    deliveredAt?: Date;
    readAt?: Date | null;
  };
  messageId?: string;
  read?: boolean;
  name?: string;
  time?: number | Date;
  messageType: "normal" | "support";
};

export type AddMessage = {
  roomId: string;
  message: Message;
};

export type AcknowledgeMessage = {
  roomId: string;
  messageId: string;
};

export type UserMessages = Array<{
  opportunitySuggestionId: string;
  messages: Message[];
}>;

export type ApplicableOpportunitySuggestion = Pick<
  OpportunitySuggestion,
  | "caseSalary"
  | "opportunityStartTime"
  | "opportunityEndTime"
  | "caseSalary"
  | "familyPrice"
  | "caregiverId"
  | "opportunitySuggestionState"
> & {
  firstname: string;
  opportunitySuggestionId: string;
  avatar: string;
  age: number;
  familyId: string;
};

export interface TypingUsers {
  [roomId: string]: string[];
}

export type AddTypingUser = {
  roomId: string;
  name: string;
};

export interface ConnectedUsers {
  [roomId: string]: string[];
}

export type AddConnectedUser = {
  roomId: string;
  name: string;
};

export type Rooms = ApplicableOpportunitySuggestion[];
export type Messages = {
  [roomId: string]: Message[];
};

export type MessagesState = {
  typing: TypingUsers;
  messages: Messages;
  rooms: Rooms;
  connected: ConnectedUsers;
  newMessages: number;
};

export const initialAppState: MessagesState = {
  typing: {},
  messages: {},
  rooms: [],
  connected: {},
  newMessages: 0,
};
